import { generalApi } from '@/lib/api/general';
import { Law } from '@/interfaces/api/general/law';
import { Regulation } from '@/interfaces/api/general/regulation';

// Module-level cache (persists across page navigations within the same session)
let lawsCache: Law[] | null = null;
let regulationsCache: Regulation[] | null = null;
let lawsPromise: Promise<Law[]> | null = null;
let regulationsPromise: Promise<Regulation[]> | null = null;

export const useMasterData = () => {
  const fetchAllLaws = async (): Promise<Law[]> => {
    if (lawsCache) return lawsCache;
    if (lawsPromise) return lawsPromise;
    lawsPromise = generalApi
      .getLaws()
      .then((res) => {
        lawsCache = res.data;
        lawsPromise = null;
        return lawsCache;
      })
      .catch((e) => {
        lawsPromise = null;
        throw e;
      });
    return lawsPromise;
  };

  const fetchAllRegulations = async (): Promise<Regulation[]> => {
    if (regulationsCache) return regulationsCache;
    if (regulationsPromise) return regulationsPromise;
    regulationsPromise = generalApi
      .getRegulations()
      .then((res) => {
        regulationsCache = res.data;
        regulationsPromise = null;
        return regulationsCache;
      })
      .catch((e) => {
        regulationsPromise = null;
        throw e;
      });
    return regulationsPromise;
  };

  return { fetchAllLaws, fetchAllRegulations };
};
